// Derives normalised numeric fields from opportunity + meta strings.
// Kept in one place so filters, sorts, and labels agree on the same numbers.

/** Parse the capitalRequired mock string to an approximate midpoint in USD. */
const CAPITAL_HINTS = [
  { match: /(\d+)\s*[-–]\s*(\d+)\s*مليون\s*ريال/, unit: 0.27 * 1_000_000, mode: "range" },
  { match: /(\d+)\s*مليون\s*ريال/, unit: 0.27 * 1_000_000 },
  { match: /(\d+)\s*مليون\s*درهم/, unit: 0.27 * 1_000_000 },
  { match: /(\d+)\s*مليون\s*دولار/, unit: 1_000_000 },
  { match: /(\d+)\s*مليار\s*دولار/, unit: 1_000_000_000 },
];

export const deriveCapitalUSD = (meta = {}) => {
  const raw = (meta.capitalRequired || "").replace(/[،,]/g, "");
  if (!raw) return null;
  // Convert Arabic-Indic digits to Latin so regex works.
  const normalized = raw.replace(/[٠-٩]/g, (d) =>
    String("٠١٢٣٤٥٦٧٨٩".indexOf(d)),
  );
  for (const hint of CAPITAL_HINTS) {
    const m = normalized.match(hint.match);
    if (m) {
      if (hint.mode === "range") {
        const [, lo, hi] = m;
        return ((Number(lo) + Number(hi)) / 2) * hint.unit;
      }
      return Number(m[1]) * hint.unit;
    }
  }
  return null;
};

/** Rough "days ago" from Arabic publishedAt strings. */
export const deriveDaysAgo = (str = "") => {
  const s = str.trim();
  if (!s) return 999;
  if (s.includes("ساعات") || s.includes("اليوم")) return 0;
  if (s.includes("أمس")) return 1;
  if (s.includes("أسبوع")) return 7;
  const norm = s.replace(/[٠-٩]/g, (d) =>
    String("٠١٢٣٤٥٦٧٨٩".indexOf(d)),
  );
  const dayMatch = norm.match(/(\d+)\s*(يوم|أيام)/);
  if (dayMatch) return Number(dayMatch[1]);
  return 4;
};

const TIME_ORDER = { urgent: 0, "30-days": 1, flexible: 2 };
export const deriveExecutionSpeed = (meta = {}) =>
  TIME_ORDER[meta.timeSensitivity] ?? 3;

const RISK_WEIGHT = { high: 3, medium: 2, low: 1 };
export const deriveRiskScore = (meta = {}) => {
  const risks = meta.risks || [];
  if (risks.length === 0) return 0;
  return risks.reduce((sum, r) => sum + (RISK_WEIGHT[r.level] ?? 1), 0);
};
